import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const navigate = useNavigate()

    return (
        <motion.footer
            className="relative py-12 bg-gradient-to-t from-black to-gray-900 border-t border-gray-800 overflow-hidden"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
        >
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5">
                <div className="absolute inset-0" style={{
                    backgroundImage: `radial-gradient(circle at 25px 25px, rgba(255,255,255,0.3) 2%, transparent 0%), radial-gradient(circle at 75px 75px, rgba(255,255,255,0.3) 2%, transparent 0%)`,
                    backgroundSize: '100px 100px'
                }}></div>
            </div>

            <div className="max-w-6xl mx-auto px-4 relative z-10">
                {/* Main Footer Content */}
                <div className="flex flex-col items-center space-y-6">
                    {/* Copyright Text */}
                    <motion.p
                        className="text-lg max-md:text-sm font-light text-white tracking-wide max-md:text-center"
                        initial={{ y: 20, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.2, duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        © {currentYear} The Angels Universe. All rights reserved.
                    </motion.p>

                    {/* About Us Link */}
                    <motion.div
                        initial={{ y: 20, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <div
                            // to="/about"
                            className="group relative inline-flex items-center text-white hover:text-white transition-colors duration-300 font-medium"
                        >
                            <span className="relative" onClick={() => navigate("/about")}>
                                About Us
                                <motion.span
                                    className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-red-600 to-orange-500 group-hover:w-full transition-all duration-300"
                                    whileHover={{ width: "100%" }}
                                />
                            </span>

                            {/* Animated Arrow */}
                            <motion.svg
                                className="w-4 h-4 ml-2 transform group-hover:translate-x-1 transition-transform duration-300"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                                whileHover={{ x: 5 }}
                                transition={{ type: "spring", stiffness: 400 }}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                            </motion.svg>
                        </div>
                    </motion.div>

                    {/* Decorative Divider */}
                    <motion.div
                        className="w-24 h-px bg-gradient-to-r from-transparent via-gray-600 to-transparent"
                        initial={{ width: 0 }}
                        whileInView={{ width: 96 }}
                        transition={{ delay: 0.6, duration: 0.8 }}
                        viewport={{ once: true }}
                    />

                    {/* Optional Tagline */}
                    <motion.p
                        className="text-base text-white text-center max-w-md italic"
                        initial={{ y: 20, opacity: 0 }}
                        whileInView={{ y: 0, opacity: 1 }}
                        transition={{ delay: 0.8, duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        Where heroes rise from the darkness
                    </motion.p>
                </div>

                {/* Floating Elements */}
                <div className="absolute top-4 left-8 opacity-10">
                    <motion.div
                        animate={{
                            y: [0, -10, 0],
                            rotate: [0, 5, 0]
                        }}
                        transition={{
                            duration: 6,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                        className="text-2xl"
                    >
                        ⚡
                    </motion.div>
                </div>

                <div className="absolute bottom-4 right-8 opacity-10">
                    <motion.div
                        animate={{
                            y: [0, 10, 0],
                            rotate: [0, -5, 0]
                        }}
                        transition={{
                            duration: 5,
                            repeat: Infinity,
                            ease: "easeInOut",
                            delay: 1
                        }}
                        className="text-2xl"
                    >
                        🛡️
                    </motion.div>
                </div>
            </div>
        </motion.footer>
    );
};

export default Footer;